import { Button, Flex, Typography, Alert } from 'antd';
import { MFABackupCodes } from '../../MFABackupCodes';

const { Title } = Typography;

interface BackupStepProps {
  codes: string[];
  onComplete: () => void;
}

export const BackupStep = ({ codes, onComplete }: BackupStepProps) => (
  <Flex vertical gap={16}>
    <Title level={5}>Save Backup Codes</Title>
    <Alert
      type="warning"
      title="Save these backup codes in a secure location. Each code can only be used once to sign in if you lose access to your authenticator app."
    />
    <MFABackupCodes codes={codes} />
    <Button type="primary" onClick={onComplete}>
      Done
    </Button>
  </Flex>
);
